import React, { useState } from "react"
import Layout from "../../components/layout"
import Image from "../../components/image"
import Hero from "../../components/hero"
import PeopleGrid from "../../components/people-grid"
import ReadNext from "../../components/read-next"
import Page from "../../components/page"
import { PageColumns, Column } from "../../components/page-column"

function ManagementPhoto({ image, name, title, classes }) {
  return (
    <figure
      className={
        classes ? `management-team__photo ${classes}` : `management-team__photo`
      }
    >
      <Image path={image} />
      <figcaption className="management-team__photo__info">
        <div className="management-team__photo__info__title">{title}</div>
        <div className="management-team__photo__info__name">{name}</div>
      </figcaption>
    </figure>
  )
}

export default function IMFOrganizationChart() {
  const [peopleOverlayActive, setPeopleOverlayActive] = useState(false)
  const toggleOverlayVisibility = () => {
    setPeopleOverlayActive(!peopleOverlayActive)
  }

  return (
    <Layout>
      <Hero title="Executive Directors & Management Team" basic />

      <Page>
        <PageColumns>
          <Column classes="text-block">
            <h2 style={{ marginBottom: 5 }}>
              Executive Directors & Alternates
            </h2>
            <p>
              The Executive Board is responsible for conducting the day-to-day
              business of the IMF. It is composed of 24 Executive Directors, who
              are elected by member countries or by groups of countries, and the
              Managing Director, who serves as its Chair.
            </p>
            <p>
              All IMF member countries are represented on its Executive Board,
              which discusses the national, regional, and global consequences of
              each member’s economic policies and approves IMF financing to help
              member countries address temporary balance of payments problems,
              as well as oversees the IMF’s capacity development efforts.
            </p>
            <button
              className="cta--primary"
              onClick={() => setPeopleOverlayActive(!peopleOverlayActive)}
              style={{ marginTop: 30 }}
            >
              See Executive Directors & Constituency
            </button>
          </Column>
        </PageColumns>

        <PeopleGrid
          id="Executive Directors"
          overlayActive={peopleOverlayActive}
          toggleOverlayVisibility={toggleOverlayVisibility}
        />

        <section className="management-team">
          <div className="management-team__row management-team__row--intro">
            <ManagementPhoto
              image="who-we-are/executive-directors-management-team/kristalina-georgieva.jpg"
              name="Kristalina Georgieva"
              title="Managing Director"
            />

            <div className="management-team__intro">
              <h2>Management Team</h2>
              <p>
                <b>The IMF has a Managing Director,</b> who is head of the staff
                and Chair of the Executive Board. The Managing Director is
                assisted by a First Deputy Managing Director and three other
                Deputy Managing Directors.
              </p>
            </div>
          </div>

          <div className="management-team__row">
            <ManagementPhoto
              image="who-we-are/executive-directors-management-team/gita-gopinath.jpg"
              name="Gita Gopinath"
              title="First Deputy Managing Director"
            />
            <ManagementPhoto
              image="who-we-are/executive-directors-management-team/antoinette-sayeh.jpg"
              name="Antoinette Sayeh"
              title="Deputy Managing Director"
            />
          </div>

          <div className="management-team__row">
            <ManagementPhoto
              image="who-we-are/executive-directors-management-team/kenji-okamura.jpg"
              name="Kenji Okamura"
              title="Deputy Managing Director"
            />
            <ManagementPhoto
              image="who-we-are/executive-directors-management-team/bo-li.jpg"
              name="Bo Li"
              title="Deputy Managing Director"
            />
          </div>
        </section>
      </Page>

      <ReadNext sectionID="who-we-are" pageID="resources" />
    </Layout>
  )
}
